import { render } from "./eventView.vue?vue&type=template&id=cb1c1114&scoped=true&ts=true"
import script from "./eventView.vue?vue&type=script&lang=ts&config=true"
export * from "./eventView.vue?vue&type=script&lang=ts&config=true"

import "./eventView.vue?vue&type=style&index=0&id=cb1c1114&scoped=true&lang=css"
import "./eventView.vue?vue&type=style&index=1&id=cb1c1114&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb1c1114"]])

export default __exports__